import CreateAsyncAction from "../../utils/actions";

// export enum AppActionTypes {
// 	SET_HEADER_TITLE="SET_HEADER_TITLE",
// 	SET_CLIENT_ID = "SET_CLIENT_ID",
// 	SET_CLIENT_STATE = "SET_CLIENT_STATE",
// 	SET_CLIENT_NONCE = "SET_CLIENT_NONCE",
// 	CHANGE_CURRENT_FORM = "CHANGE_CURRENT_FORM",
// }


// export interface SetHeaderTitleAction {
// 	type: typeof AppActionTypes.SET_HEADER_TITLE;
// 	payload: string;
// 	meta?: any;
// }

// export interface SetClientIdAction {
// 	type: typeof AppActionTypes.SET_CLIENT_ID;
// 	payload: string;
// 	meta?: any;
// }

// export interface SetClientStateAction {
// 	type: typeof AppActionTypes.SET_CLIENT_STATE;
// 	payload: string;
// 	meta?: any;
// }

// export interface SetClientNonceAction {
// 	type: typeof AppActionTypes.SET_CLIENT_NONCE;
// 	payload: string;
// 	meta?: any;
// }

// export interface ChangeCurrentFormAction {
// 	type: typeof AppActionTypes.CHANGE_CURRENT_FORM;
// 	payload: number;
// 	meta?: any;
// }

export const SetHeaderTitle = CreateAsyncAction<string>('SetHeaderTitle');
export const SetClientId = CreateAsyncAction<string>('SetClientId');
export const SetClientState = CreateAsyncAction<string>('SetClientState');
export const SetRedirectUrl = CreateAsyncAction<string>('SetRedirectUrl');
export const SetClientNonce = CreateAsyncAction<string>('SetClientNonce');
export const ChangeCurrentForm = CreateAsyncAction<number>('ChangeCurrentForm');


export interface HomeState {
	headerTitle: string;
	clientId: string;
	clientState: string;
	clientNonce: string;
	redirectUrl: string;
	currentForm: number;
}
